import { TFunction } from 'i18next'
import { MBI_REGEX } from 'utils/mbi-validator'

type GeneratorWithTranslation = (t: TFunction) => Record<string, unknown>
interface FieldRuleGenerator {
  mbi: GeneratorWithTranslation,
  firstName: GeneratorWithTranslation,
  lastName: GeneratorWithTranslation,
  zipCode: GeneratorWithTranslation,
  emailAddress: GeneratorWithTranslation,
  callbackNumber: GeneratorWithTranslation,
  planName: GeneratorWithTranslation,
  planContractId: GeneratorWithTranslation,
  descriptionOfComplaint: GeneratorWithTranslation
}

export const fieldRuleGenerator: FieldRuleGenerator = {
  mbi: t => ({
    required: { value: true, message: t('incompleteInformation.mbi') },
    pattern: { value: MBI_REGEX, message: t('incompleteInformation.mbi') }
  }),
  firstName: t => {
    const message = t('incompleteInformation.firstNameRequired')
    return {
      required: { value: true, message },
      pattern: { value: /^[a-zA-Z .,\-']+$/, message },
      // This is for safety in case someone misses putting the maxLength input attribute value
      maxLength: { value: 24, message }
    }
  },
  lastName: t => {
    const message = t('incompleteInformation.lastNameRequired')
    return {
      required: { value: true, message },
      pattern: { value: /^[a-zA-Z .,\-']+$/, message },
      // This is for safety in case someone misses putting the maxLength input attribute value
      maxLength: { value: 24, message }
    }
  },
  zipCode: t => {
    const message = t('incompleteInformation.zip')
    return {
      required: { value: true, message },
      pattern: { value: /^\d+$/, message },
      minLength: { value: 5, message },
      maxLength: { value: 5, message }
    }
  },
  emailAddress: t => {
    const message = t('Error Enter your email address')
    return {
      required: { value: true, message },
      pattern: { value: /^[A-Za-z0-9](([_.-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([.-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/, message }
    }
  },
  callbackNumber: t => {
    const message = t('Error Enter a valid call back number')
    return {
      required: { value: true, message },
      minLength: { value: 10, message },
      maxLength: { value: 10, message }
    }
  },
  planName: t => {
    const message = t('Error Enter your plan name')
    return {
      required: { value: true, message },
      pattern: { value: /^[a-zA-Z0-9\s-]+/, message }
    }
  },
  planContractId: t => {
    const message = t('Error Enter your plan contract ID')
    return {
      required: { value: true, message },
      pattern: { value: /^[a-zA-Z0-9\s-]+$/i, message }
    }
  },
  descriptionOfComplaint: t => {
    const requiredMessage = t('descriptionOfComplaintErrorMessages.required')
    const invalidLengthOrSpecialCharacters = t('descriptionOfComplaintErrorMessages.invalidLengthOrSpecialCharacters')
    return {
      required: { value: true, message: requiredMessage },
      maxLength: { value: 1500, message: invalidLengthOrSpecialCharacters },
      pattern: { value: /^[a-zA-Z0-9.,;:'!?\s$%@#()-]+$/, message: invalidLengthOrSpecialCharacters }
    }
  }
}
